export default __webpack_public_path__ + "static/media/連云暄.2ec3a6a3.jpg";